import React, { Component, Fragment } from 'react';
import { base_url } from '../../globalConstants'
import { Table, Row, Col, Image, Nav, ButtonGroup, Button } from 'react-bootstrap';
import M from "materialize-css";
import { EditOutlined } from "@material-ui/icons";
import Axios from 'axios';
import './addHomeDelivery.css';


class HomeDeliveryFrag extends Component {
  constructor(props) {
    super(props);
    this.state = ({

        countryId: "",processing_fee:"",brokerage_charge:"",insurance_charge:"",
        flatRate: "", initialRange: "", finalRange: "", unitCharge: "", flag: '',
        brokerState: '', unitCharge: '', city: '', zipcode: '', stateName: '',
        homedeliveryData: this.props.homedelivery_data, 
        countryNameList: this.props.country_name,
        countrylist: this.props.countrylist, countrycodelist: this.props.country_code_list, error: "",
        countryName:"", editRow: false, mainId:"", keyId:"",
        statedata: this.props.statedata, stateCode_list: [], stateName_list:[],
        statelist: [], stateSelectOptions: [], isDisabledFlat: true, isDisabledSlab: false 
    })

    // console.log('country_name_list',this.state.countryNameList);
  }

  handleCountryNameChange = async (e) => {
    // this.setState({countryname: e.target.value})
    // @TODO: on changing countryname state list should also Change

    this.setState({ countryName: e.target.value })
    console.log("country selected:- " + e.target.value)
    // this.setState({countryname:e.target.value})


    let selected_countryId = this.state.countrycodelist[this.state.countrylist.indexOf(e.target.value)]
    console.log(selected_countryId)

    const states = this.state.statedata[this.state.countrylist.indexOf(e.target.value)].slice()
    console.log(states)

    this.setState({ countryId: selected_countryId, statelist: states })
    // this.setState({statelist:states})
    console.log(this.state.countryId)
    console.log("state list")
    console.log(this.state.statelist)
    // this.state.statelist


    /////TESTTTTTTT  

    this.setState({ tempStateList: states })
    console.log(this.state.tempStateList)
    console.log(typeof this.state.tempStateList)
    
    /////TESTTTTTTTT END

  }

  handleStateChange = (e) => {
    console.log("state of homedelivery", e.target.value)
    this.setState({ brokerState: e.target.value })
    console.log(this.state.brokerState);
  }

  handleFlatRateChange = (e) => {
    this.setState({ flatRate: e.target.value })
  }
  
  handleInsuranceChargeChange = (e) => {
    this.setState({ insurance_charge: e.target.value })
  }
  
  handleBrokerageChargeChange = (e) => {
    this.setState({ brokerage_charge: e.target.value })
  }
  
  handleProcessingFeeChange = (e) => {
    this.setState({ processing_fee: e.target.value })
  }
  
  handleInitialRangeChange = (e) => {
    this.setState({ initialRange: e.target.value })
  }
  handleFinalRangeChange = (e) => {
    this.setState({ finalRange: e.target.value })
  }
  handleUnitChargeChange = (e) => {
    this.setState({ unitCharge: e.target.value })
  }  
  // handleCityChange = (e) => {
  //   this.setState({ city: e.target.value })
  // }  
  // handleZipcodeChange = (e) => {
  //   this.setState({ zipcode: e.target.value })
  // }  
  handleFlagChange = (e) => {
      // console.log('fflag',e.target);
      console.log('fflag',e.target.value);
      this.setState({ flag: e.target.value })
      if (e.target.value === "Flat") {
        this.setState({ isDisabledFlat: true });
        this.setState({ isDisabledSlab: false });
      }else{
        this.setState({ isDisabledFlat: false });
        this.setState({ isDisabledSlab: true });
      }
  }


//EDIT OPTION START
handleEditOption = (e) => {
  this.setState({editRow:true})
  var elems = document.getElementById("addHomeDeliveryModal");
  var instance = M.Modal.init(elems);
  instance.open()

  let selectedRowIndex ;
              e = e || window.event;
              var data = [];
              var target = e.srcElement || e.target;
              // console.log(target.nodeName)
              while (target && target.nodeName !== "TR") {
                  target = target.parentNode;
                  selectedRowIndex= target.sectionRowIndex
                  console.log("Clicked row",target.sectionRowIndex)
                  // console.log(target.parentNode.index)
              }
              if (target) {
                  var cells = target.getElementsByTagName("td");
                  for (var i = 0; i < cells.length; i++) {
                      data.push(cells[i].innerHTML);
                  }
              } 
              
              let country_name = this.state.countrylist[this.state.countrycodelist.indexOf(data[6])]
              
              // let country_name = country_name[data[1]]   

              console.log(country_name);

            

              //start on 150621
              const statesOnEdit = this.state.statedata[this.state.countrylist.indexOf(data[6])].slice()
              
              console.log(statesOnEdit);
              this.setState({ statelist: statesOnEdit })

              let finalstatearr=[];

              for(var i=0;i<statesOnEdit.length;i++)
              {
                let statedataobj={
              state_id:statesOnEdit[i].state_id.toString(),
              state_name:statesOnEdit[i].state_name,
              state_code:statesOnEdit[i].state_code

                };
                finalstatearr.push(statedataobj);
              }

              console.log(finalstatearr);
              this.setState({ statelist: finalstatearr })

                     // setTimeout(this.setState({warehouseState: "1"}), 3000);

              
            //  this.setState({ warehouseState: "1"})

            var newArray = statesOnEdit.filter(function(item) {
              return item.state_name == data[5];
            });

            var setselectedstatevalue='';
            if(newArray && newArray.length>0)
            {
            setselectedstatevalue=newArray[0].state_id.toString();
            }

            console.log(newArray);
            //end on 150621

              console.log(data);
              if (data[10] === "Flat") {
                this.setState({ isDisabledFlat: true });
                this.setState({ isDisabledSlab: false });
              }else{
                this.setState({ isDisabledFlat: false });
                this.setState({ isDisabledSlab: true });
              }

              this.setState({mainId: data[0], keyId: data[14]})
              this.setState({
//edit on 160621
                //countryId: "",
                countryId: data[11],
                flatRate: data[4], 
                initialRange: data[1], 
                finalRange: data[2],
                brokerState: setselectedstatevalue, 
                unitCharge: data[3], 
                //city: data[7], 
                //zipcode: data[8], 
                // countryName: country_name,
                countryName: data[6],
                flag: data[13],
				insurance_charge: data[7],
				brokerage_charge: data[8],
				processing_fee: data[9],
              })
}

openAddHomeDeliveryModal =  ()=>{
  this.setState({editRow:false})
  this.setState({
    flatRate:'', initialRange: '', finalRange: '', flag: '',insurance_charge:'',processing_fee:'',brokerage_charge:'',
    brokerState: '', unitCharge: '', city: '', zipcode: '', 
  }) 
  // here again reset the all fields on add new broker 

  var elems = document.getElementById("addHomeDeliveryModal");
  var instance = M.Modal.init(elems);
  instance.open()
        
}
closeModal = ()=>{
  var elems = document.getElementById("addHomeDeliveryModal");
  var instance = M.Modal.init(elems);
  instance.close();
  this.setState({error: "", editRow:false})
  this.setState({
    flatRate:'', initialRange: '', finalRange: '', flag: '',brokerage_charge:'',processing_fee:'',
    brokerState: '', unitCharge: '', city: '', zipcode: '', insurance_charge:'',
  })  
}

updateHomeDeliveryDB = async () => {
  // console.log("UPDATE FUNCT")

  let country_code = this.state.countrycodelist[this.state.countrylist.indexOf(this.state.countryName)]
  let url = base_url+`homedelivery/${this.state.keyId}/`

    var brokerformdata = new FormData()
    brokerformdata.append("country", this.state.countryId)
    brokerformdata.append('flat_rate',this.state.flatRate)
    brokerformdata.append('intial_range',this.state.initialRange)
    brokerformdata.append('final_range',this.state.finalRange)
    brokerformdata.append('slab_rate',this.state.unitCharge)
    brokerformdata.append('state',this.state.brokerState)
    // brokerformdata.append('city',this.state.city)
    // brokerformdata.append('zipcode',this.state.zipcode)
    brokerformdata.append('rate_type',this.state.flag)
	brokerformdata.append('insurance',this.state.insurance_charge)
	brokerformdata.append('brokerage',this.state.brokerage_charge)
	brokerformdata.append('processing', this.state.processing_fee)
    

    try {
      let token = localStorage.getItem("token")
      var config = {
        headers: { 'Content-Type': 'multipart/form-data' , 'Authorization':'Token '+token},
        
      };
      const response = await Axios.put(url, brokerformdata, config)
  
      let itemIndex = parseInt(this.state.mainId) - 1
      this.state.homedeliveryData.splice(itemIndex, 1, response.data)
  
      var elem = document.getElementById('addHomeDeliveryModal')
      var instance = M.Modal.getInstance(elem);
      instance.close();
      M.toast({ html: 'Updated Home Delivery Details Successfully.' , classes: "white-text orange rounded" })
      this.setState({
        countryId: "",
        flatRate:'', initialRange: '', finalRange: '', flag: '',
        brokerState: '', unitCharge: '', city: '', zipcode: '', insurance_charge:'',brokerage_charge:'',processing_fee:'',
      })
      this.setState({
        error: "",
        editRow: false
      })
    } catch (err) {
      this.setState({
        error: "OH Snap! Something is Wrong.Please try again",
        // editRow: false
      })
      M.toast({ html: 'Please Try Again!', classes: "white-text red rounded" });
  
      console.log(err.message)
    }

}
//EDIT OPTION END


addHomeDeliveryToDB = async () => {
    // console.log('ADD FUNCT');

    var brokerformdata = new FormData()
    brokerformdata.append("country", this.state.countryId)
    brokerformdata.append('flat_rate',this.state.flatRate)
    brokerformdata.append('intial_range',this.state.initialRange)
    brokerformdata.append('final_range',this.state.finalRange)
    brokerformdata.append('slab_rate',this.state.unitCharge)
    brokerformdata.append('state',this.state.brokerState)
    // brokerformdata.append('city',this.state.city)
    // brokerformdata.append('zipcode',this.state.zipcode)
    brokerformdata.append('rate_type',this.state.flag)
	brokerformdata.append('insurance',this.state.insurance_charge)
	brokerformdata.append('brokerage',this.state.brokerage_charge)
	brokerformdata.append('processing', this.state.processing_fee)
        
    let url = base_url+'homedelivery/'

    try{
      let token = localStorage.getItem('token')
      var config = {
        headers:{
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Token'+token,
        }    
      };

      const response = await Axios.post(url, brokerformdata, config)
      this.state.homedeliveryData.push(response.data)
      console.log('push response data', response.data);

      var elem = document.getElementById('addHomeDeliveryModal')
      var instance = M.Modal.getInstance(elem);
      instance.close();
      this.setState({
        countryId: "",
        flatRate:'', initialRange: '', finalRange: '',
        brokerState: '', unitCharge: '', city: '', zipcode: '', insurance_charge:'',brokerage_charge:'',processing_fee:'',
        error: ""
      })

      M.toast({ html: 'Added Home Delivery Details Successfully.', classes: "white-text orange rounded" })

    }catch(err) {
      console.log('ERRRR',err);
      this.setState({
        error: "OH Snap! Something is Wrong.Please try again"
      })
      M.toast({ html: 'Please Try Again!', classes: "white-text red rounded" });

    }

  }

  componentDidMount() {
    // Auto initialize all the things!
    M.AutoInit();

  }


  render() {

    var uniquekey = 0
    const selectCounrtyOptions = this.state.countrylist.map((country) => {

      return (
        <option key={uniquekey++} value={country}>{country}</option>
      )
    })

    const selectStateOptions = this.state.statelist.map((state, index) => {
      // console.log("state", state)

      return (

        <option key={index} value={state.state_id}>{state.state_name}</option>
      )
    })


    const homedelivery_table = this.state.homedeliveryData.map((broker, index) => {
      return (
        <Fragment key={broker.id}>
          <tr>
            <td>{index+1}</td>
            <td>{broker.intial_range}</td>
            <td>{broker.final_range}</td>
            <td>{broker.slab_rate}</td>
            <td>{broker.flat_rate}</td>
            <td>{broker.state_name}</td>
            <td>{ this.state.countryNameList[broker.country] }</td>
			<td>{broker.insurance}</td>
			<td>{broker.brokerage}</td>
			<td>{broker.processing}</td>
            <td onClick={this.handleEditOption}><a title = "Edit"><EditOutlined/></a></td>
            <td className="hide">{broker.country}</td>
            <td className="hide">{broker.state}</td>
            <td className="hide">{broker.rate_type}</td>
            <td className="hide">{broker.id}</td>
          </tr>
        </Fragment>

      )
    })

    const table_render = <Table hover >
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th>Initial(LBS)</th>
          <th>Final(LBS)</th>
          <th>Unit Charge</th>
          <th>Flat Rate</th>
          <th>State</th>
          <th>Country</th>
		  <th>Insurance Fee</th>
		  <th>Brokerage Fee</th>
		  <th>Consolidation Fee</th>
          <th>Edit</th>
        </tr>
      </thead>
      <tbody>
        {homedelivery_table}
      </tbody>
    </Table>

    return (
      <Fragment>
        <br></br>
        <br></br>
        {/* <div className="">
    <AddCountry ref="child"/>
        </div> */}




        {/* <!-- Modal Trigger --> */}
        <div id="addHomeDeliveryModal" className="modal modal-fixed-footer brokermodal">
          <div className="modal-content">

          <h4 className="center orange-text"> {this.state.editRow ? "Update Rate Details" : "Add Rate Details"}</h4>

            <h4 className="center orange-text">   </h4>

            <Row>
              <Col xs={12} >
                <form>
                  <p className="center red-text">{this.state.error}</p>

                  <Row>
                    <Col className=" rowdivPading " xs={12}>
                      <div className="input-field col s6 offset-s3">
                        <div id=''>
                        {
                            this.state.editRow
                            ? <select id="country_name_selct" name="country_name" className="browser-default country_name_select" value={this.state.countryName} onChange={this.handleCountryNameChange}>
                              <option value="" disabled >Choose Country</option>
                              {selectCounrtyOptions}

                            </select>
                            : <select id="country_name_selct" name="country_name" className="browser-default country_name_select" defaultValue={'DEFAULT'} onChange={this.handleCountryNameChange}>
                              <option value="DEFAULT" disabled >Choose Country</option>
                              {selectCounrtyOptions}
                            </select>
                          }
                          <label>Select Country</label>

                        </div>
                      </div>  
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading " xs={12}>
                      <div className="input-field col s6 offset-s3">
                        <div>

                          {
                            this.state.editRow
                              ? <select id="state_name_select" name="stateName" className="browser-default " value={this.state.brokerState} onChange={this.handleStateChange}>
                                <option value="" disabled >Choose State </option>
                                {selectStateOptions}
                              </select>
                              : <select id="state_name_select" name="stateName" className="browser-default " defaultValue={'DEFAULT'} onChange={this.handleStateChange}>
                                <option value="DEFAULT" disabled >Choose State </option>
                                {selectStateOptions}
                              </select>
                          }
                          <label>Select State</label>

                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading " xs={12}>
                      <div className="input-field col s6 offset-s3">
                        <div>
                          {
                            this.state.editRow
                              ? <select id="selectType" name="selectType" className="browser-default " value={this.state.flag} onChange={this.handleFlagChange}>
                                {/* <option value="" disabled >Select Flag </option> */}
                                  <option key='0' value='Flat'>Flat</option>
                                  <option key='1' value='Slab'>Slab</option>
                              </select>
                              : <select id="selectType" name="selectType" className="browser-default " defaultValue={'DEFAULT'} onChange={this.handleFlagChange}>
                                {/* <option value="DEFAULT" disabled >Select Flag </option> */}
                                  <option key='0' value='Flat'>Flat</option>
                                  <option key='1' value='Slab'>Slab</option>
                              </select>
                          }
                          <label>Select Rate Type</label>

                        </div>
                      </div>
                    </Col>
                  </Row>
<Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="insurance_charge" id="insurance_charge" type="text" 
                          value={this.state.insurance_charge} onChange={this.handleInsuranceChargeChange} className="" />
                        <label htmlFor="insurance_charge" className={this.state.insurance_charge?"black-text active":"black-text"}>Enter Insurance Fee</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Insurance Fee</span>
                      </div>
                    </Col>
                  </Row>
				  
				  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="brokerage_charge" id="brokerage_charge" type="text" 
                          value={this.state.brokerage_charge} onChange={this.handleBrokerageChargeChange} className="" />
                        <label htmlFor="brokerage_charge" className={this.state.brokerage_charge?"black-text active":"black-text"}>Enter Brokerage Fee</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Brokerage Fee</span>
                      </div>
                    </Col>
                  </Row>
				  
				 <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="processing_fee" id="processing_fee" type="text" 
                          value={this.state.processing_fee} onChange={this.handleProcessingFeeChange} className="" />
                        <label htmlFor="processing_fee" className={this.state.processing_fee?"black-text active":"black-text"}>Enter Consolidation Fee</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Consolidation Fee</span>
                      </div>
                    </Col>
                  </Row>
	
	
                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="flatrate_name" id="flatrate_name" type="text" 
                          value={this.state.flatRate} onChange={this.handleFlatRateChange} className="" disabled={this.state.isDisabledSlab} />
                        <label htmlFor="flatrate_name" className={this.state.flatRate?"black-text active":"black-text"}>Enter Flat Rate</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Flat Rate</span>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="initialrange_name" id="initialrange_name" type="text" 
                          value={this.state.initialRange} onChange={this.handleInitialRangeChange} className="" disabled={this.state.isDisabledFlat} />
                        <label htmlFor="initialrange_name" className={this.state.initialRange?"black-text active":"black-text"}>Enter Initial Range</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Lower LBS</span>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="finalrange_name" id="finalrange_name" type="text" 
                          value={this.state.finalRange} onChange={this.handleFinalRangeChange} className="" disabled={this.state.isDisabledFlat} />
                        <label htmlFor="finalrange_name" className={this.state.finalRange?"black-text active":"black-text"}>Enter Final Range</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Upper LBS </span>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="unitcharge_name" id="unitcharge_name" type="text" 
                          value={this.state.unitCharge} onChange={this.handleUnitChargeChange} className="" disabled={this.state.isDisabledFlat} />
                        <label htmlFor="unitcharge_name" className={this.state.unitCharge?"black-text active":"black-text"}>Enter Unit Charge</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Unit Charge</span>
                      </div>
                    </Col>
                  </Row>

                </form>
              </Col>
            </Row>
          </div>
          <div className="modal-footer">
            {/* <a href="#!" className="modal-close waves-effect waves-green btn-flat">Agree</a> */}

            <ButtonGroup className="mr-2" aria-label="First group">
              <Button id='cancelBrokerBtn' variant="outline-secondary" className="mr-4 btn modal-close "  >Cancel</Button>
              {
              this.state.editRow
              ?<Button id="updateBrokerBtn" variant="outline-primary" className="mr-2 btn" onClick = {this.updateHomeDeliveryDB}>Update</Button>
              :<Button id="addBrokerBtn" variant="outline-primary" className="mr-2 btn" onClick={this.addHomeDeliveryToDB}> Add</Button>
              }   
            </ButtonGroup>

          </div>
        </div>

        <div className="">
          <Row>
            <Col xs={12} md={12} lg={12} >
              <div className="tableheight">
                {table_render}
              </div>
            </Col>

          </Row>
          <Row>
            <Col >

              <Nav className="right">
                <Nav.Link className="red-text modal-trigger " href="" onClick={this.openAddHomeDeliveryModal}>
                  Add Home Delivery Details<Image className="red-text mr-auto" src="assets/images/plus-circle-red-m.svg" /></Nav.Link>
              </Nav>


            </Col>
          </Row>
        </div>


      </Fragment>
    )
  }

}


export default HomeDeliveryFrag;